export default __webpack_public_path__ + "static/top1-7f2dcfb1fbd1fdbd932d2be5d6a0bd8f.svg";